import { KeyValuePairCollection } from './kvp.collection';

export const UserStatus: KeyValuePairCollection<number> = new KeyValuePairCollection<number>([
  { key: 'Active', value: 1 },
  { key: 'Inactive', value: 2 },
  { key: 'Locked Out', value: 4 },
  { key: 'Registered (Pending)', value: 3 }
]);
